// extracted by mini-css-extract-plugin
export default {"container":"Container_container__RYZjL","label":"Container_label__rpmrP","inputContainer":"Container_inputContainer__pW4Zx","fieldset":"Container_fieldset__b1FDJ"};